import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, InputAdornment, InputLabel, OutlinedInput, Avatar, InputBase, SvgIcon, Grid, Typography, IconButton, Box, Paper } from "@material-ui/core"
import Swal from 'sweetalert2';
import { Condicion } from "./Condicion";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120,
  },
  divColor: {
    minWidth: 120,
    width: "100%",
    maxWidth:"50px",
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderRadius: "4px",
    
  },
  icon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    maxWidth: theme.spacing(3),
    maxHeight: theme.spacing(3),
  },

  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    maxWidth: theme.spacing(4),
    maxHeight: theme.spacing(4),
    cursor: "pointer",
  },
  pre: {
    color: "white !important",
  }

}));


export const Conexion = React.memo(({details = false, size, name, caption, formik, initialState = "", title, readOnly = true, onChange, variant = "outlined"}) => {

  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(()=>formik ? formik.values[name] : initialState);
  const error = formik && formik.touched[name] && formik.errors[name];
  const hasError = Boolean(error);

  useEffect(()=>{
  }, [])

  useEffect(()=>{
      formik ? actualizarFormik() : onChange({target:{name, value: value}})
  }, [value])

  const actualizarFormik = () => {
    value !== formik.values[name] && formik.setFieldValue(name, value);
  }

   const handleValueChange = (value) => {
    setOpen(false);
    setValue(value);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleOpen = (event) => {
    setOpen(true);
  }

  const classes = useStyles();

  const InputCode = variant === "standard" ? InputBase : OutlinedInput;

  return (

    <div style={{ margin: 8, width: "100%" }} >
      <FormControl fullWidth variant={variant} className={classes.formControl}  onClick={handleOpen} error={hasError}>
        {variant === "oulined" &&
          <InputLabel  htmlFor={`${name}-${variant}-color`} shrink={value} error={hasError}>
            {caption}
          </InputLabel>
        }
        <InputCode 
          size={size}
          readOnly={true}
          id={`${name}-${variant}-color`}
          type="text" 
          endAdornment={
            <InputAdornment position="end">
              <Avatar className={classes.avatar} style={{backgroundColor: "#bdbdbd", width:20, height:20, padding: 0}} >
                <CSharpIcon style={{width:18, height:18}} className={classes.icon}/>
              </Avatar>
            </InputAdornment>
          }
          value={value ? "Condición" : ""}
          label={caption}
          onClick={handleOpen}
          style={
            variant === "standard" ? {        
              border: "0px solid white",
              borderBottom: "0px solid #949494",
              borderRadius: "0px",
              cursor: "pointer"
            } : {
              cursor: "pointer"
            }
          }
        />
        {hasError &&
          <FormHelperText>{error}</FormHelperText>
        }
      </FormControl>
      <DialogConexionCondicion value={value} caption={caption} open={open} onClose={handleClose} onChange={handleValueChange}/>

    </div>


  )
})


const DialogConexionCondicion = ({value, open, onClose, onChange}) => {


  const [values, setValues] = useState(()=>value && value.map((x, i) => ({id: i, ...x})) || [])
  const [next, setNext] = useState(values.length);
  const handleAgregarCondicion = (grupo) => {
    setValues(values => [
      ...values, 
      {
        id: next,
        transformador1: {nombre: "Término 1", tipoTransformacion: "FORMULA", valorOrigen: "", valorDestino: "", formula: ""}, 
        transformador2: {nombre: "Término 2", tipoTransformacion: "FORMULA", valorOrigen: "", valorDestino: "", formula: ""}, 
        operacion: "IGUAL", 
        grupo: `${grupo}`,
      }
    ]);
    setNext(next => next + 1);
  }

  const handleChangeCondicion = (newValues, id) => {
    setValues( values => values.map( item => item.id === id ? {...newValues, id} : item ) );
  }

  const handleRemoveCondicion = (id) => {

    Swal
      .fire({
        icon: 'question',
        title: 'Eliminar condición',
        html: `Está seguro de eliminar esta condición?<br/>`,
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cerrar',
      })
      .then((result) => {
        if (result.isConfirmed) {
          setValues( values => values.filter( item => item.id !== id ));
        }
      });
    
  }

  const handleRemoveGrupo = (grupo) => {

    Swal
    .fire({
      icon: 'question',
      title: 'Eliminar grupo',
      html: `Está seguro de eliminar este grupo?<br/>`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cerrar',
    })
    .then((result) => {
      if (result.isConfirmed) {
        setValues( values => values.filter( item => item.grupo !== grupo ));
      }
    });
    
  }

  const handleAgregarGrupo = () => {
    handleAgregarCondicion(agrupadas.reverse()[0].grupo * 1 + 1);
  }

  const agrupadas = useMemo(() => values.sortByProp("grupo").groupBy(
    x => x.grupo, 
    (grupo, items) => ({grupo, items})
  ), [values]);

  return (
    <>
      <Dialog open={open}  aria-labelledby="form-dialog-title" onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle id="form-dialog-title">

          <Box display="flex" alignItems="center">
            <Box flexGrow={1} >Edición de condiciones</Box>
            <Box>
              {agrupadas.length > 0 &&
                <Button onClick={()=>handleAgregarGrupo()}>Agregar grupo</Button>
              }
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          {agrupadas.map((grupo) =>
            <Grupo key={grupo.grupo} grupo={grupo.grupo} items={grupo.items} onRemove={handleRemoveCondicion} onRemoveGrupo={handleRemoveGrupo} onChange={handleChangeCondicion} onAdd={handleAgregarCondicion}/>
          )}
          {
            agrupadas.length===0 &&
            <Button onClick={()=>handleAgregarCondicion(1)}>Agregar condición</Button>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={()=>onChange(values)}>Aceptar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const Grupo = ({grupo, items, onRemove, onChange, onAdd, onRemoveGrupo}) => {

  return (
    <>
    
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} >      
          <Typography variant="h6">Grupo: {grupo} <Button onClick={()=>onAdd(grupo)}>Agregar condición</Button></Typography> 
        </Box>
        <Box>
          <Button onClick={()=>onRemoveGrupo(grupo)}>Borrar grupo</Button>
        </Box>
      </Box>
      {
        items.map( condicion =>
          <Condicion key={condicion.id} {...condicion} onRemove={()=>onRemove(condicion.id)} onChange={(values)=>onChange(values, condicion.id)}/>
        )
      }
    </>
  )

}

const CSharpIcon = (props) => {

  return (
    <SvgIcon {...props} viewBox="0 0 48 48" >
      <path fill="#37474f" fill-rule="evenodd"
        d="M22.903,3.286c0.679-0.381,1.515-0.381,2.193,0 c3.355,1.883,13.451,7.551,16.807,9.434C42.582,13.1,43,13.804,43,14.566c0,3.766,0,15.101,0,18.867 c0,0.762-0.418,1.466-1.097,1.847c-3.355,1.883-13.451,7.551-16.807,9.434c-0.679,0.381-1.515,0.381-2.193,0 c-3.355-1.883-13.451-7.551-16.807-9.434C5.418,34.899,5,34.196,5,33.434c0-3.766,0-15.101,0-18.867 c0-0.762,0.418-1.466,1.097-1.847C9.451,10.837,19.549,5.169,22.903,3.286z"
        clip-rule="evenodd"></path>
      <path fill="#546e7a" fill-rule="evenodd"
        d="M5.304,34.404C5.038,34.048,5,33.71,5,33.255 c0-3.744,0-15.014,0-18.759c0-0.758,0.417-1.458,1.094-1.836c3.343-1.872,13.405-7.507,16.748-9.38 c0.677-0.379,1.594-0.371,2.271,0.008c3.343,1.872,13.371,7.459,16.714,9.331c0.27,0.152,0.476,0.335,0.66,0.576L5.304,34.404z"
        clip-rule="evenodd"></path>
      <path fill="#fff" fill-rule="evenodd"
        d="M24,10c7.727,0,14,6.273,14,14s-6.273,14-14,14 s-14-6.273-14-14S16.273,10,24,10z M24,17c3.863,0,7,3.136,7,7c0,3.863-3.137,7-7,7s-7-3.137-7-7C17,20.136,20.136,17,24,17z"
        clip-rule="evenodd"></path>
      <path fill="#455a64" fill-rule="evenodd"
        d="M42.485,13.205c0.516,0.483,0.506,1.211,0.506,1.784 c0,3.795-0.032,14.589,0.009,18.384c0.004,0.396-0.127,0.813-0.323,1.127L23.593,24L42.485,13.205z"
        clip-rule="evenodd"></path>
      <path fill="#fff" fill-rule="evenodd" d="M34 20H35V28H34zM37 20H38V28H37z" clip-rule="evenodd"></path>
      <path fill="#fff" fill-rule="evenodd" d="M32 25H40V26H32zM32 22H40V23H32z" clip-rule="evenodd"></path>
    </SvgIcon>
  
  )
}
